import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { IntroducersService } from 'src/app/services/api/introducers.service';
import { RouteService } from 'src/app/services/route.service';
import { CommonService } from 'src/app/services/common.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { AccessControlService } from 'src/app/services/access-control.service';

@Component({
  selector: 'app-introducer-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './introducer-index-page.component.html',
  styleUrl: './introducer-index-page.component.scss',
})
export class IntroducerIndexPageComponent implements OnInit, OnDestroy {
  baseIndexPageConfig: BaseIndexPageConfig;
  private subscriptions = new Subscription();

  constructor(
    protected introducersService: IntroducersService,
    private routeService: RouteService,
    private commonService: CommonService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService,
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Introducers',
      cardTitle: 'Introducers',
      dataTable: {
        data: [],
        searchModel: {
          name: null,
          address: null,
          city: null,
          vat: null,
          contractStartTime: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => item.name,
          }),
          new DataTableColumnText({
            attribute: 'address',
            header: 'Address',
            filter: 'text',
            value: (item: any) => item.address,
          }),
          new DataTableColumnText({
            attribute: 'city',
            header: 'City',
            filter: 'text',
            value: (item: any) => item.city,
          }),
          new DataTableColumnText({
            attribute: 'vat',
            header: 'Vat',
            filter: 'text',
            value: (item: any) => item.vat,
          }),
          new DataTableColumnText({
            attribute: 'contractStartTime',
            header: 'Contract Start Time',
            filter: 'text',
            value: (item: any) => item.contractStartTime ? this.commonService.formatDate(new Date(item.contractStartTime)) : '',
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View introducer details',
                onClick: (item: any) => this.routeService.introducerDetail(item.introducerId),
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit introducer',
                onClick: (item: any) => this.routeService.introducerUpdate(item.introducerId),
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete introducer',
                isDelete: true,
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data =
                    this.baseIndexPageConfig.dataTable.data.filter(
                      (i: any) => i.introducerId !== item.introducerId
                    );
                },
              },
            ],
          }),
        ],
      },
      apiListService: (options: ApiOptionsConfig) => this.introducersService.list(options),
      responseListModelName: 'introducers',
    };
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        const canCreate = this.accessControlService.hasFeatureActionAccess(profileCode, 'INTRODUCER_LIST', 'modify');
        this.baseIndexPageConfig.addNewItemButton = canCreate
          ? {
              type: 'success',
              title: 'Create Introducer',
              onClick: () => this.routeService.introducerCreate(),
            }
          : undefined;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
